import React, { useState } from "react";
import { Download } from "lucide-react";
import { ArtifactDownloadButtonProps } from "../../types";
import { apiService } from "../../services/api";

export const ArtifactDownloadButton: React.FC<ArtifactDownloadButtonProps> = ({
  workflowId,
  stepId,
  artifactKey,
  artifactType,
  fileName,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    try {
      setIsDownloading(true);
      const blob = await apiService.downloadArtifact(
        workflowId,
        stepId,
        artifactKey
      );

      // Create blob URL and trigger download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up URL
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download artifact:", error);
      alert("Failed to download artifact. Please try again.");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <button
      onClick={handleDownload}
      disabled={isDownloading}
      className="inline-flex items-center px-3 py-2 text-sm font-medium text-green-700 bg-green-50 border border-green-300 rounded-md hover:bg-green-100 dark:bg-green-900/20 dark:text-green-300 dark:border-green-600 dark:hover:bg-green-900/30 disabled:opacity-50 transition-colors"
    >
      <Download className="w-4 h-4 mr-2" />
      {isDownloading ? "Downloading..." : "Download"}
    </button>
  );
};
